import React, { useEffect, useState } from "react";
import Header from "../directives/header";
import Footer from "../directives/footer";
import Sidebar from "../directives/sidebar";
import { GetAdminProfileDetails, updateAdminProfile } from "../Action/action";
import toast, { Toaster } from "react-hot-toast";
import config from "../coreFIles/config";
import { Col, Row } from "react-bootstrap";

const Profile = () => {
  const [AdminProfile, setAdminProfile] = useState({
    email: "",
    fname: "",
    lname: "",
    profileImg: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getAdminProfile();
  }, []);

  const getAdminProfile = async () => {
    const res = await GetAdminProfileDetails();
    if (res.status) {
      setAdminProfile({
        email: res.data.email,
        fname: res.data.fname,
        lname: res.data.lname,
        profileImg: res.data.profileImg
          ? res.data.profileImg
          : "",
      });
    }
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "email":
        if (!value.trim()) error = "Email is required.";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Invalid email format.";
        else if (value.length > 50)
          error = "Email must be less than 50 characters.";
        break;
      case "fname":
      case "lname":
        if (!value.trim())
          error = `${name === "fname" ? "First" : "Last"} name is required.`;
        else if (value.length < 2)
          error = `${name === "fname" ? "First" : "Last"
            } name must be at least 2 characters.`;
        else if (value.length > 50)
          error = `${name === "fname" ? "First" : "Last"
            } name must be less than 50 characters.`;
        else if (!/^[a-zA-Z\s]+$/.test(value))
          error = `${name === "fname" ? "First" : "Last"
            } name can only contain letters and spaces.`;
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminProfile((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    let error = "";

    if (file) {
      const validExtensions = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/svg+xml",
      ];
      if (!validExtensions.includes(file.type)) {
        error = "Only PNG, JPEG, JPG, and SVG files are allowed.";
      } else if (file.size > 10 * 1024 * 1024) {
        error = "File size must be less than 10 MB.";
      }
    } else {
      error = "Profile image is required.";
    }

    setErrors((prev) => ({ ...prev, profileImg: error }));
    setSelectedFile(error ? null : file);
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(AdminProfile).forEach((key) => {
      if (key !== "profile") {
        const error = validateField(key, AdminProfile[key]);
        if (error) newErrors[key] = error;
      }
    });

    if (!selectedFile && !AdminProfile.profileImg) {
      newErrors.profileImg = "Profile image is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const SubmitForm = async () => {
    if (isSubmitting || !validateForm()) return;
    setIsSubmitting(true);
    toast.dismiss();
    try {
      let data = {
        fname: AdminProfile.fname,
        lname: AdminProfile.lname,
        email: AdminProfile.email,
      };

      const payload = { ...data, files: selectedFile };
      console.log(payload);
      const res = await updateAdminProfile(payload);

      if (res.status) {
        toast.success("Profile updated successfully!");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        toast.error("Failed to update profile.");
        setIsSubmitting(false);
      }
    } catch (error) {
      toast.error("An error occurred while updating the profile.");
      setIsSubmitting(false);
    }
  };

  const imagePreview = selectedFile
    ? URL.createObjectURL(selectedFile)
    : AdminProfile.profileImg;

  return (
    <>
      <div className="wrapper">
        <Header />
        <Toaster />
        <Sidebar />

        <div className="content-wrapper">
          <div className="container-full">
            <section className="content">
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="box">
                    <div className="box-header with-border">
                      <h3 class="box-title " style={{ fontWeight: "600" }}>
                        Profile
                      </h3>
                    </div>
                    <div className="p-4">
                      <Row>
                        <Col lg={6} xl={4}>
                          <div className="form-group row mb-4 px-15">
                            <label className="col-form-label px-0">
                              First Name
                            </label>
                            <input
                              className={`form-control ${errors.fname ? "is-invalid" : ""
                                }`}
                              type="text"
                              name="fname"
                              value={AdminProfile.fname}
                              onChange={handleChange}
                            />
                            {errors.fname && (
                              <div className="invalid-feedback">
                                {errors.fname}
                              </div>
                            )}
                          </div>
                        </Col>

                    

                        <Col lg={6} xl={4}>
                          <div className="form-group row mb-4 px-15">
                            <label className="col-form-label px-0">
                              Last Name
                            </label>
                            <input
                              className={`form-control ${errors.lname ? "is-invalid" : ""
                                }`}
                              type="text"
                              name="lname"
                              value={AdminProfile.lname}
                              onChange={handleChange}
                            />
                            {errors.lname && (
                              <div className="invalid-feedback">
                                {errors.lname}
                              </div>
                            )}
                          </div>
                        </Col>

                        <Col lg={6} xl={4}>
                          <div className="form-group row mb-4 px-15">
                            <label className="col-form-label px-0">Email</label>
                            <input
                              className={`form-control ${errors.email ? "is-invalid" : ""
                                }`}
                              type="text"
                              disabled
                              name="email"
                              value={AdminProfile.email}
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <div className="invalid-feedback">
                                {errors.email}
                              </div>
                            )}
                          </div>
                        </Col>

                            <Col lg={6} xl={4}>
                          <div className="form-group row mb-4 px-15">
                            <label className="col-form-label px-0">Profile</label>
                           
                            <input
                              type="file"
                              className={`form-control ${errors.profileImg ? "is-invalid" : ""
                                }`}
                              accept="image/png, image/jpeg, image/jpg, image/svg"
                              onChange={handleFileChange}
                            />
                           
                          </div>
                            {imagePreview && (
                              <img
                                src={imagePreview}
                                alt="profileImg"
                                className="img-fluid rounded-circle mb-2"
                                style={{
                                  width: "75px",
                                  height: "75px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                            {errors.profileImg && (
                              <div className="invalid-feedback">
                                {errors.profileImg}
                              </div>
                            )}
                        </Col>

                        <Col md={12} className="text-end">
                          <div>
                            <hr />
                            <button
                              type="submit"
                              onClick={SubmitForm}
                              className="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Updating..." : "Update"}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Profile;
